import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function Stars({
  size = 'w-4 h-4'
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-hidden="true" data-id="element-141" data-mp="20t9uto15uv6a">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className={`${size} fill-amber-400 text-amber-400`} data-id="element-142" data-mp="1mxy03gn094pd" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-143" data-mp="1d0tb791ryv4v">
      <div className="max-w-6xl mx-auto" data-id="element-144" data-mp="1d47eqkm6dadw">
        <div className="text-center mb-16" data-id="element-145" data-mp="1i17keuf44b4h">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-146" data-mp="1hyuthrrdmqfa">
            Lo que dicen las profes de Argentina.
          </h2>
          <div className="flex items-center justify-center gap-2 text-brand-gray font-medium" data-id="element-147" data-mp="1828al8im29fw">
            <Stars size="w-5 h-5" data-id="element-148" data-mp="2yeo18lckn6c4" />
            <span data-id="element-149" data-mp="2yfpbwopodqtb">4.9/5 &middot; +1.200 profes en todo el país</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-150" data-mp="32g97voyiiodv">
          {testimonials.map(t => <figure key={t.name} className="bg-brand-panel rounded-3xl p-8 flex flex-col h-full border border-brand-creamDark/60" data-id="element-151" data-mp="2uzhrnbchx0db">
              <Stars data-id="element-152" data-mp="34q2ooucitwu4" />
              <blockquote className="text-brand-text font-medium my-6 leading-relaxed" data-id="element-153" data-mp="34qm9citk2zbu">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-154" data-mp="2c26sdqqv66xv">
                <span className="w-10 h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-155" data-mp="2c4jjouiihtnl">
                  {t.initials}
                </span>
                <span data-id="element-156" data-mp="2lyjmuqu8goto">
                  <span className="block font-bold text-brand-text text-sm" data-id="element-157" data-mp="2h230o26lgkj8">
                    {t.name}
                  </span>
                  <span className="block text-xs text-brand-gray" data-id="element-158" data-mp="19cd7zy66rl1">
                    {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}